export class MenuItem {
    constructor(
        // public isHome: boolean = false,
        // public ParentMenuId: number,
        // public MenuName: string,
        // public MenuClass: string,
        // public UiPageName: string,
        // public Title: string,
        // public Icon: string,
        // public ActClass: string,
        // public ModuleId:number, //missed
        // public Childrens: SubMenuItem[]
    ) {}
    public isHome: boolean = false;
        public ParentMenuId: number;
        public MenuName: string;
        public MenuClass: string;
        public UiPageName: string;
        public Title: string;
        public Icon: string;
        public ActClass: string;
        public ModuleId?:number; //missed
        public IsExternal:boolean;
        public Childrens: SubMenuItem[];
}

export class SubMenuItem {
    constructor(
        // public ParentMenuId: number,
        // public MenuId: number,
        // public Icon: string,
        // public MenuClass: string,
        // public ActClass: string,
        // public Title: string,
        // public Routelink: string,
        // public UiPageName: string,
        // public IsMenu: number, //missed
        // public MenuName:string,//missed
        // public ModuleId:number,//missed
        // public Childrens: SubMenuItem[], //missed
    ) { }
    public ParentMenuId: number;
        public MenuId: number;
        public Icon: string;
        public MenuClass: string;
        public ActClass: string;
        public Title: string;
        public Routelink: string;
        public UiPageName: string;
        public IsMenu: number; //missed
        public MenuName:string;//missed
        public ModuleId?:number;//missed
        public IsExternal:boolean;
        public Childrens: SubMenuItem[]; //missed
} 

export class Logo {
    fileName: string;
    filePath: string;
    attachment: any;
}